import _slicedToArray from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { createContext, useReducer } from 'react';
import { MsgReadStatus } from '@/api/affiliate/data/bff/homepage'; // SET_ANNOUNCEMENT_LIST_INFO: including set announcement list, set current page, set current cursor, set current total number, set list status;
// SET_CURRENT_ANNOUNCEMENT_DETAIL: including set current announcement, set current content status
// MARK_AS_READ: mark current announcement as read;
export var HomeModuleContextActionType = /*#__PURE__*/function (HomeModuleContextActionType) {
  HomeModuleContextActionType[HomeModuleContextActionType["SET_ANNOUNCEMENT_LIST_INFO"] = 0] = "SET_ANNOUNCEMENT_LIST_INFO";
  HomeModuleContextActionType[HomeModuleContextActionType["SET_CURRENT_ANNOUNCEMENT_DETAIL"] = 1] = "SET_CURRENT_ANNOUNCEMENT_DETAIL";
  HomeModuleContextActionType[HomeModuleContextActionType["MARK_AS_READ"] = 2] = "MARK_AS_READ";
  HomeModuleContextActionType[HomeModuleContextActionType["RESET_STATE"] = 3] = "RESET_STATE";
  return HomeModuleContextActionType;
}({});
export var ApiStatus = /*#__PURE__*/function (ApiStatus) {
  ApiStatus[ApiStatus["LOADING"] = 0] = "LOADING";
  ApiStatus[ApiStatus["SUCCESS"] = 1] = "SUCCESS";
  ApiStatus[ApiStatus["ERROR"] = 2] = "ERROR";
  return ApiStatus;
}({});
export var announcementDefaultValue = {
  announcementsList: {
    curAnnouncementList: [],
    curPage: 0,
    totalNum: 0,
    curAnnouncementListStatus: ApiStatus.LOADING
  },
  curAnnouncementDetail: {
    curAnnouncement: {},
    curAnnouncementBodyStatus: ApiStatus.LOADING
  }
};
export var HomeModuleContext = /*#__PURE__*/createContext(announcementDefaultValue);
var setAnnouncementAsRead = function setAnnouncementAsRead(state, ids) {
  var newAnnouncementsList = state.announcementsList.curAnnouncementList.map(function (i) {
    var toBeMarked = ids.includes(i.message_id);
    if (toBeMarked) {
      i.read_status = MsgReadStatus.STATUS_READ;
    }
    return i;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    announcementsList: _objectSpread(_objectSpread({}, state.announcementsList), {}, {
      curAnnouncementList: newAnnouncementsList
    })
  });
};
var reducer = function reducer(state, action) {
  switch (action.type) {
    case HomeModuleContextActionType.SET_ANNOUNCEMENT_LIST_INFO:
      return _objectSpread(_objectSpread({}, state), {}, {
        announcementsList: action.payload
      });
    case HomeModuleContextActionType.SET_CURRENT_ANNOUNCEMENT_DETAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        curAnnouncementDetail: action.payload
      });
    case HomeModuleContextActionType.MARK_AS_READ:
      return setAnnouncementAsRead(state, action.payload);
    case HomeModuleContextActionType.RESET_STATE:
      return _objectSpread(_objectSpread({}, state), announcementDefaultValue);
    default:
      return state;
  }
};
export var useHomeModuleContext = function useHomeModuleContext() {
  var _useReducer = useReducer(reducer, announcementDefaultValue),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  return _objectSpread(_objectSpread({}, state), {}, {
    dispatch: dispatch
  });
};